// export const API_URL = "https://api.melhorseguro.com.br";
export const API_URL = process.env.REACT_APP_BACKEND_ENDPOINT || 'https://api.melhorsegurodev.com.br'
// export const API_URL = "http://localhost:4000";
export const hotelCategories = [
    { id: 6, name: 'Montanha' },
    { id: 5, name: 'Praia' },
    { id: 4, name: 'Natureza' },
    { id: 3, name: 'Boutique' },
    { id: 2, name: 'Resort' },
    { id: 1, name: 'Geral' },
]

export const DESTINATIONS_CODES = {
    "Brasil": 2,
    "Oceania": 3,
    "Europa": 5,
    "Brasil Receptivo (Estrangeiros)": 6,
    "Ásia": 7,
    "América do Norte": 8,
    "América do Sul": 9,
    "América Central": 10,
    "África": 11,
    "Oriente Médio": 12,
    "América Central e Caribe": 13,
    "México": 15,
    "Multiviagens (seguro anual)": 16,
    "Canadá": 19,
    "Internacional (com EUA/Canadá)": 21,
    "Internacional (exceto EUA/Canadá)": 22,
    "Cruzeiro Marítimo América Latina": 24,
    "Cruzeiro Marítimo Europa": 25,
    "Cruzeiro Marítimo Mundo": 26
};

export const DESTINATION_CATEGORY_CODES = {
    1: "Regiões",
    2: "Países",
    3: "Cruzeiros",
    4: "Mundo",
    5: "Outros",
    6: "Copa do Mundo"
}

